module.exports = __webpack_public_path__ + "static/img/chufeng.22e59e45.gif";